import { createClient } from "@supabase/supabase-js";
import { CONFIG } from "./config.ts";

export { type Session } from "@supabase/supabase-js";

/**
 * The browser Supabase client. Its session, kept in this origin's
 * `localStorage`, is the single sign-on session: every OAuth client is sent
 * to the consent page here, and a person signed in here approves without
 * signing in again. PKCE keeps the return from Google a `?code=` exchange,
 * which `detectSessionInUrl` completes on the page sign-in returns to.
 */
export const supabase = createClient(
  CONFIG.supabaseUrl,
  CONFIG.supabasePublishableKey,
  {
    auth: {
      flowType: "pkce",
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
